import { ZOOM } from '@/libs/enum'

const state = {
  data: {
    name: '大安區',
    position: {
      lat: 25.0199289,
      lng: 121.5489956
    },
    zoom: ZOOM.POINT,
    paths: [
      { lat: 25.02992220420659, lng: 121.54393158937988 },
      { lat: 25.00966142980037, lng: 121.53658963228759 },
      { lat: 25.01899502351986, lng: 121.56129084612427 },
      { lat: 25.02661693204239, lng: 121.5619594671875 }
    ]
  }
}

const getters = {
  data ({ data }) {
    return data
  }
}

const actions = {}

const mutations = {}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
